import Vue from 'vue';

import Router from 'vue-router';
import {
  REFRESH_TOKEN_TIME,
  TOKEN_EXPIRED_TIME
} from '@/env';

import Auth from '@/pages/Auth';
import Registration from '@/pages/Registration';
import ExecutionList from '@/pages/ExecutionList';
import HomePage from '@/pages/HomePage';
import TargetPredictionExecuteView from
  '@/pages/TargetPrediction/ExecuteView';
import TargetPredictionResultView from
  '@/pages/TargetPrediction/ResultView';
import PathwayPredictionExecuteView from
  '@/pages/PathwayPrediction/ExecuteView';
import PathwayPredictionResultView from
  '@/pages/PathwayPrediction/ResultView';
  import HitGenerationDownloadView from
  '@/pages/HitGeneration/DownloadView';
import ReactionGenerationDownloadView from
  '@/pages/ReactionGeneration/DownloadView';
import YamanishiMenu from '@/components/Yamanishi/Menu';
import GroupManagement from '@/pages/GroupManagement';

import NotFound from '@/pages/special/NotFound';
import ForbiddenPage from '@/pages/special/Forbidden';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'MLPlatform',
      components: {
        menu: YamanishiMenu,
        main: HomePage
      },
      meta: {
        title: 'Home',
        manualPage: 1
      }
    },
    {
      path: '/login',
      name: 'Auth',
      components: {
        main: Auth
      },
      meta: {
        title: 'Login'
      }
    },
    {
      path: '/registration',
      name: 'Registration',
      components: {
        main: Registration
      },
      meta: {
        title: 'Registration'
      }
    },
    {
      path: '/executions',
      name: 'ExecutionList',
      components: {
        menu: YamanishiMenu,
        main: ExecutionList
      },
      meta: {
        title: 'Execution History'
      }
    },
    {
      path: '/target_prediction/',
      name: 'TargetPredictionExecuteView',
      components: {
        menu: YamanishiMenu,
        main: TargetPredictionExecuteView
      },
      meta: {
        title: 'Target Prediction',
        manual: 'TargetPredictionManual.pdf'
      }
    },
    {
      path: '/target_prediction/:id',
      name: 'TargetPredictionResultView',
      components: {
        menu: YamanishiMenu,
        main: TargetPredictionResultView
      },
      meta: {
        title: 'Target Prediction',
        manual: 'TargetPredictionManual.pdf'
      }
    },
    {
      path: '/pathway_prediction/',
      name: 'PathwayPredictionExecuteView',
      components: {
        menu: YamanishiMenu,
        main: PathwayPredictionExecuteView
      },
      meta: {
        title: 'Pathway Prediction',
        manual: 'PathwayPredictionManual.pdf'
      }
    },
    {
      path: '/pathway_prediction/:id',
      name: 'PathwayPredictionResultView',
      components: {
        menu: YamanishiMenu,
        main: PathwayPredictionResultView
      },
      meta: {
        title: 'Pathway Prediction',
        manual: 'PathwayPredictionManual.pdf'
      }
    },
    {
      path: '/hit_generation/download',
      name: 'HitGenerationDownloadView',
      components: {
        menu: YamanishiMenu,
        main: HitGenerationDownloadView
      },
      meta: {
        title: 'Download Hit Generation Models',
        manualPage: 3
      }
    },
    {
      path: '/reaction_generation/download',
      name: 'ReactionGenerationDownloadView',
      components: {
        menu: YamanishiMenu,
        main: ReactionGenerationDownloadView
      },
      meta: {
        title: 'Download Reaction Generation Models',
        manualPage: 3
      }
    },
    {
      path: '/groups',
      name: 'GroupManagement',
      components: {
        menu: YamanishiMenu,
        main: GroupManagement
      },
      meta: {
        title: 'Group Management'
      }
    },
    {
      path: '*',
      name: 'NotFound',
      components: {
        menu: YamanishiMenu,
        main: NotFound
      },
      meta: {
        title: 'Page not found'
      }
    },
    {
      path: '*',
      name: 'Forbidden',
      components: {
        menu: YamanishiMenu,
        main: ForbiddenPage
      },
      meta: {
        title: 'Access denied'
      }
    }
  ]
});

router.beforeEach((toRoute, fromRoute, next) => {
  const session = Vue.prototype.$session;
  session.start();
  const tokenUsageTime = (Date.now() - session.get('tokenInitTime')) / 1000;
  if (tokenUsageTime > TOKEN_EXPIRED_TIME) {
    session.destroy();
  }
  if (tokenUsageTime > REFRESH_TOKEN_TIME &&
      tokenUsageTime < TOKEN_EXPIRED_TIME) {
    Vue.api.refreshToken(session.get('token'), function(res) {
      session.set('token', res.data.token);
      session.set('tokenInitTime', Date.now());
    }, function() {
      session.destroy();
    });
  }
  next();
});

router.beforeEach((toRoute, fromRoute, next) => {
  if (toRoute.meta && toRoute.meta.title) {
    window.document.title = 'Omics-Based Drug Discovery In DAIIA Platform - ' + toRoute.meta.title;
  } else {
    window.document.title = 'Omics-Based Drug Discovery In DAIIA Platform';
  }
  next();
});

router.beforeEach((toRoute, fromRoute, next) => {
  const session = Vue.prototype.$session;
  session.start();
  const currentUser = session.get('user');
  if (toRoute.name === 'GroupManagement' &&
    currentUser &&
    currentUser.owned_groups.length === 0) {
    router.push({ name: 'Forbidden' });
  }
  next();
});

export default router;
